import axios from 'axios';

import {
  UPDATE_SALES_INVOICE_PAYMENT,
  UPDATE_SALES_INVOICE_PAYMENT_SUCCESS,
  UPDATE_SALES_INVOICE_PAYMENT_FAILURE,
  RESET_SALES_INVOICE_PAYMENT,
} from './type';
import { SALES_INVOICE_PAYMENT_URL } from './url';
import { DEFAULT_ERROR } from '../components/Common/constants';
import { isGGI } from './root_url'

export function updateSalesInvoicePayment(pk, { Note, PaymentStatusRecord }) {
  return dispatch => {
    const token = localStorage.getItem('token');
    dispatch(requestUpdateSalesInvoicePayment());
    return axios({
      method: 'put',
      url: `${SALES_INVOICE_PAYMENT_URL}${pk}/payment/`,
      data: { Note, PaymentStatusRecord },
      headers: { Authorization: `Bearer ${token}` },
    }).then(response => {
      dispatch(updateSalesInvoicePaymentSuccess(response));
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch(requestUpdateSalesInvoicePaymentFailure(err));                     
      }
    });
  };
}

export function requestUpdateSalesInvoicePayment() {
  return {
    type: UPDATE_SALES_INVOICE_PAYMENT,
  };
}

export function updateSalesInvoicePaymentSuccess(payload) {
  return {
    type: UPDATE_SALES_INVOICE_PAYMENT_SUCCESS,
    payload,
  };
}

export function requestUpdateSalesInvoicePaymentFailure(payload) {
  return {
    type: UPDATE_SALES_INVOICE_PAYMENT_FAILURE,
    payload,
  };
}

export function resetSalesInvoicePayment() {
  return {
    type: RESET_SALES_INVOICE_PAYMENT,
  };
}



// WEBPACK FOOTER //
// ./master/jsx/actions/salesInvoicePayment_actions.jsx